// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DatePairController from "./date_pair_controller"
application.register("date-pair", DatePairController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReadmoreController from "./readmore_controller"
application.register("readmore", ReadmoreController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SubmitFlatpickrController from "./submit_flatpickr_controller"
application.register("submit-flatpickr", SubmitFlatpickrController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
